import React from "react";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {Button} from "react-bootstrap";
import {StyledModal, StyledModalBody, StyledModalFooter} from "../styles";

const messages = defineMessages({
  no: {
    id: "default.no",
    defaultMessage: "No",
  },
  ok: {
    id: "default.ok",
    defaultMessage: "Yes",
  },
  validatedAmount: {
    id: "loyaltyCustomerHistorical.infoTooltip.spentAmount.validatedAmount",
    defaultMessage: "Currently validated amount: {currencyCode} {amount}"
  },
  pendingAmount: {
    id: "loyaltyCustomerHistorical.infoTooltip.spentAmount.pendingAmount",
    defaultMessage: "Amount to be validated: {currencyCode} {amount}"
  },
  spentAmountHelperText: {
    id: "loyaltyCustomerHistorical.infoTooltip.spentAmount.helperText",
    defaultMessage: "*For loyalty tier upgrading, bookings amount with check-in date + 1 day passed will be validated based on the current day"
  },
  validatedBookings: {
    id: "loyaltyCustomerHistorical.infoTooltip.transactionsNumber.validatedBookings",
    defaultMessage: "Currently validated bookings: {bookings}"
  },
  pendingBookings: {
    id: "loyaltyCustomerHistorical.infoTooltip.transactionsNumber.pendingBookings",
    defaultMessage: "Bookings to be validated: {bookings}"
  },
  transactionsNumberHelperText: {
    id: "loyaltyCustomerHistorical.infoTooltip.transactionsNumber.helperText",
    defaultMessage: "*For loyalty tier upgrading, reservations with check-in date + 1 day passed will be validated based on the current day"
  }
});

export type InfoModalProps = {
  isOpen: boolean;
  handleOnHideModal: () => void;
  content: InfoModalContentProps;
};

export interface InfoModalContentProps {
  spentAmount?: {
    validatedAmount?: number,
    pendingAmount?: number,
    currencyCode: string
  },
  transactionsNumber?: {
    validatedBookings?: number,
    pendingBookings?: number
  }
}

export function InfoModal(props: InfoModalProps) {
  const intl = useIntl();
  return (
    <StyledModal size={"lg"} centered show={props.isOpen}>
      <StyledModalBody>
        <div className="h4">
          {
            props.content.spentAmount
              ? intl.formatMessage(messages.validatedAmount, {
                currencyCode: props.content.spentAmount.currencyCode,
                amount: props.content.spentAmount.validatedAmount || 0
              })
              : intl.formatMessage(messages.validatedBookings, {
                bookings: props.content.transactionsNumber?.validatedBookings || 0
              })
          }
        </div>
        <div className="h4">
          {
            props.content.spentAmount
              ? intl.formatMessage(messages.pendingAmount, {
                currencyCode: props.content.spentAmount.currencyCode,
                amount: props.content.spentAmount.pendingAmount || 0
              })
              : intl.formatMessage(messages.pendingBookings, {
                bookings: props.content.transactionsNumber?.pendingBookings || 0
              })
          }
        </div>
        <div className="pt-3">
          {
            props.content.spentAmount
              ? <FormattedMessage {...messages.spentAmountHelperText} />
              : <FormattedMessage {...messages.transactionsNumberHelperText} />
          }
        </div>
      </StyledModalBody>
      <StyledModalFooter>
        <Button variant="primary" onClick={props.handleOnHideModal}>
          {intl.formatMessage(messages.ok)}
        </Button>
      </StyledModalFooter>
    </StyledModal>
  );
}